import request from '../utils/fetch'

export function getHouseBackStopList (data) {
  return request({
    url: '/house/backstop/getHouseBackStopList',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function getHouseBackStopInfo (data) {
  return request({
    url: '/house/backstop/getHouseBackStopInfo',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function getHouseBackStopCount (data) {
  return request({
    url: '/house/backstop/getHouseBackStopCount',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}






